import OrdersDataGrid from './OrdersDataGrid'
export default OrdersDataGrid
